import { SettingCategory } from './Setting';
import {
	AIGroupIcon,
	DashboardGroupIcon,
	DataboardsGroupIcon,
	EmailTrackingGroupIcon,
	FeaturesGroupIcon,
	PermanentGroupIcon,
	PreApprovedContentGroupIcon,
	SettingsAdministrativeGroupIcon,
} from './SettingsGroupIcons';

export interface ISettingsGroup {
	category: SettingCategory;
	/** One line on the card explaining what the group covers. Copy taken from the design. */
	description: string;
	Icon: React.FC<{ className?: string }>;
	/** Stable, URL-safe id so the open group survives a refresh. */
	slug: string;
}

/**
 * The seven groups in the order the tab presents them. `Permanent` is last and read-only; it is
 * also permission-gated at the render site, not here.
 */
export const SETTINGS_GROUPS: ISettingsGroup[] = [
	{
		category: SettingCategory.Administrative,
		description: 'Login, roles, and sending on behalf of employees',
		Icon: SettingsAdministrativeGroupIcon,
		slug: 'administrative',
	},
	{
		category: SettingCategory.Features,
		description: 'What this account can turn on: newsletters, automations, texting',
		Icon: FeaturesGroupIcon,
		slug: 'features',
	},
	{
		category: SettingCategory.AI,
		description: 'AI agents, content generation, and what they are allowed to read',
		Icon: AIGroupIcon,
		slug: 'ai',
	},
	{
		category: SettingCategory.EmailTracking,
		description: 'Opens, clicks, replies, and bounce handling',
		Icon: EmailTrackingGroupIcon,
		slug: 'email-tracking',
	},
	{
		category: SettingCategory.Dashboard,
		description: 'What users see on their home dashboard',
		Icon: DashboardGroupIcon,
		slug: 'dashboard',
	},
	{
		category: SettingCategory.PreApprovedContent,
		description: 'Compliance review workflow for outgoing content',
		Icon: PreApprovedContentGroupIcon,
		slug: 'pre-approved-content',
	},
	{
		category: SettingCategory.Databoards,
		description: 'Reporting boards, sharing, and refresh cadence',
		Icon: DataboardsGroupIcon,
		slug: 'databoards',
	},
	{
		category: SettingCategory.Permanent,
		description: 'Set at account creation — contact support to change',
		Icon: PermanentGroupIcon,
		slug: 'permanent',
	},
];

/** `Permanent` values are fixed at account creation, so its card summarises rather than edits. */
export const READ_ONLY_CATEGORY = SettingCategory.Permanent;

export const getSettingsGroup = (category: SettingCategory) =>
	SETTINGS_GROUPS.find(group => group.category === category);
